// extracted by mini-css-extract-plugin
export default {"hifi":"Home_hifi__jdPvA","App-logo-spin":"Home_App-logo-spin__ML+L7"};